export const ListQueryKey = 'projectZgmRegisters';
export const DetailQueryKey = 'projectZgmRegister';

export const Urls = {
  selectUrl: '/ZmRegistrationRecord/list',
  updateUrl: '/ZmRegistrationRecord/update',
  deleteUrl: '/ZmRegistrationRecord/delete',
  createUrl: '/ZmRegistrationRecord/create',
  detailUrl: '/ZmRegistrationRecord/info',
};
